import { render, staticRenderFns } from "./DetailsAndPricing.vue?vue&type=template&id=75f74652"
import script from "./DetailsAndPricing.ts?vue&type=script&lang=ts&external"
export * from "./DetailsAndPricing.ts?vue&type=script&lang=ts&external"
import style0 from "./DetailsAndPricing.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports